<template>
    <div>
        <PropertyWorkflows v-if="$meta.features.owners.workflows" />

        <p
            v-if="$meta.portfolio_details_tab_text"
            v-html="$meta.portfolio_details_tab_text"
        >
        </p>

        <PortfolioKeyDates v-else />
    </div>
</template>

<script>
import PortfolioKeyDates from '../components/PortfolioKeyDates.vue';
import PropertyWorkflows from "../components/PropertyWorkflows.vue";

export default {
    components: {
        PropertyWorkflows,
        PortfolioKeyDates,
    },
};
</script>
